
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cmkWO", function(module, exports) {

$parcel$export(module.exports, "MainLayout", () => $a171d54840e7d827$export$93af822566053b3e);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $xQxzY = parcelRequire("xQxzY");

var $kVysQ = parcelRequire("kVysQ");
var $6CEg5 = parcelRequire("6CEg5");

var $7Sm4c = parcelRequire("7Sm4c");

var $dIouf = parcelRequire("dIouf");

var $5vi32 = parcelRequire("5vi32");

var $c323h = parcelRequire("c323h");

var $3jwuS = parcelRequire("3jwuS");

var $ddOcd = parcelRequire("ddOcd");
const $a171d54840e7d827$export$93af822566053b3e = /*#__PURE__*/ (0, $gwFzn.memo)(({ spaceKey: spaceKey, isEdit: isEdit, enableNavigation: enableNavigation, isViewPage: isViewPage, ...otherProps })=>{
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { data: data, error: unhandledError } = (0, $xQxzY.useQuery)((0, $d2LG0.default)`query MainLayoutQuery($spaceKey:String!){space(key:$spaceKey){id lookAndFeel{content{screen{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode}}}}}`, {
        variables: {
            // When spaceKey is undefined/falsy the query is skipped, so defaulting it to
            // an empty string doesn't change the logic but merely keeps TypeScript happy.
            spaceKey: spaceKey || ''
        },
        skip: !spaceKey || isEdit || isLivePage
    });
    let error = unhandledError;
    if ((0, $dIouf.isNotFoundError)(error) || (0, $dIouf.isUnauthorizedError)(error)) {
        // The MainLayoutQuery only loads the space styling configuration, and neither error nor
        // missing configuration don't break the user experience. Unauthorized or NotFound error
        // (anonymous user, restricted or missing space/page) are handled by children components
        // of MainLayout and are part of the normal user flow, hence these can be safely muted.
        (0, $7Sm4c.markErrorAsHandled)(error);
        error = undefined;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6CEg5.PerformanceStart), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_mainLayout)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ddOcd.MainLayoutComponent), {
        ...otherProps,
        enableNavigation: isEmbeddedConfluence ? false : enableNavigation,
        screen: data?.space?.lookAndFeel?.content?.screen ?? undefined,
        isViewPage: isViewPage,
        isEdit: isEdit
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c323h.AutomatedMeetingNotesSpotlightWrapper), null));
});

});
parcelRegister("kVysQ", function(module, exports) {

$parcel$export(module.exports, "PERFORMANCE_SUBJECT_linkToPage", () => $35b50a968705ed01$export$c4d483efe8eba686);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_mainLayout", () => $35b50a968705ed01$export$1de09ba64e7728f2);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_manageWatcherDialog", () => $35b50a968705ed01$export$586856ecee8f0723);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_navigation", () => $35b50a968705ed01$export$51f018e0f9f84a74);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_navigationFMP", () => $35b50a968705ed01$export$94afb8303c61d07d);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_sideNavigationFMP", () => $35b50a968705ed01$export$fe596581250cd9fc);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_navigationView", () => $35b50a968705ed01$export$88c949ed1e388f68);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_recentDropdown", () => $35b50a968705ed01$export$1a3cc5086fadf289);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_resolvedInlineCommentsDialog", () => $35b50a968705ed01$export$b35db70015797a33);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_copyPageTree", () => $35b50a968705ed01$export$5c78998b70cdff69);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_spaceDirectory", () => $35b50a968705ed01$export$1167e4f56227df4c);
const $35b50a968705ed01$export$9960fc620d4470dd = 'comments';
const $35b50a968705ed01$export$c4d483efe8eba686 = 'link-to-page';
const $35b50a968705ed01$export$1de09ba64e7728f2 = 'main-layout';
const $35b50a968705ed01$export$586856ecee8f0723 = 'manage-watcher-dialog';
const $35b50a968705ed01$export$51f018e0f9f84a74 = 'Navigation';
const $35b50a968705ed01$export$94afb8303c61d07d = 'navigation-fmp';
const $35b50a968705ed01$export$fe596581250cd9fc = 'side-navigation-fmp';
const $35b50a968705ed01$export$88c949ed1e388f68 = 'NavigationView';
const $35b50a968705ed01$export$1a3cc5086fadf289 = 'recent-dropdown';
const $35b50a968705ed01$export$b35db70015797a33 = 'resolved-inline-comments-dialog';
const $35b50a968705ed01$export$5c78998b70cdff69 = 'copy-page-tree';
const $35b50a968705ed01$export$1167e4f56227df4c = 'space-directory';

});

parcelRegister("c323h", function(module, exports) {

$parcel$export(module.exports, "AutomatedMeetingNotesSpotlightWrapper", () => $9eab5d375ba1bffd$export$edf3ca4196271bf8);
/* AutomatedMeetingNotesSpotlightComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $lAFHW = parcelRequire("lAFHW");

var $lnqHu = parcelRequire("lnqHu");

var $91xA1 = parcelRequire("91xA1");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $1qfLF = parcelRequire("1qfLF");

var $2Nwuj = parcelRequire("2Nwuj");

var $inPa6 = parcelRequire("inPa6");

var $5U2Bi = parcelRequire("5U2Bi");

var $dlxup = parcelRequire("dlxup");
const $9eab5d375ba1bffd$var$closeIconStyle = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: "var(--ds-space-200, 16px)",
    right: "var(--ds-space-200, 16px)",
    background: "var(--ds-surface, #FFFFFF)",
    borderRadius: "var(--ds-space-200, 16px)"
});
const $9eab5d375ba1bffd$var$closeIconBackgroundStyle = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    alignItems: 'center',
    top: "var(--ds-space-300, 24px)"
});
const $9eab5d375ba1bffd$var$contentStyle = (0, $ecnYn.xcss)({
    paddingBottom: 'space.300'
});
const $9eab5d375ba1bffd$var$spotlightCardWrapperStyle = null;
const $9eab5d375ba1bffd$var$i18n = (0, $2nPZH.defineMessages)({
    spotlightTitle: {
        id: "automated-meeting-notes.spotlight.title",
        defaultMessage: "Never take another meeting note"
    },
    spotlightDescription: {
        id: "automated-meeting-notes.spotlight.description",
        defaultMessage: "Track action items, take notes, and send a meeting recap with Loom AI for meetings."
    },
    startRecording: {
        id: "automated-meeting-notes.spotlight.startRecording",
        defaultMessage: "Start recording"
    },
    closeButtonLabel: {
        id: "automated-meeting-notes.spotlight.closeButtonLabel",
        defaultMessage: "Close"
    }
});
const $9eab5d375ba1bffd$var$loomHref = 'https://www.loom.com/meetings/settings?ignore_redirect=1';
const $9eab5d375ba1bffd$export$b30968b1b90f389b = ({ onClose: onClose, pageSource: pageSource })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onStartRecording = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: pageSource,
                action: 'clicked',
                actionSubject: 'meetingNotesSpotlightCTA'
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        pageSource
    ]);
    const onSpotlightDismissed = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: pageSource,
                action: 'dismissed',
                actionSubject: 'meetingNotesSpotlightCTA'
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        pageSource
    ]);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_kqsw1n9t _1ltv1ejb _94n51ejb _1pby1rya _1g96u2gc _1vxe1ejb _fkwn1bhr _1pks1cd0 _tml11fxt"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $91xA1.default), {
        width: 480,
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($5U2Bi))),
            alt: "",
            width: "480px"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $9eab5d375ba1bffd$var$closeIconStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                xcss: $9eab5d375ba1bffd$var$closeIconBackgroundStyle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lnqHu))), iconProps)),
        shape: "circle",
        appearance: "subtle",
        label: formatMessage($9eab5d375ba1bffd$var$i18n.closeButtonLabel),
        onClick: ()=>{
            onClose();
            onSpotlightDismissed();
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        gap: "space.200",
        xcss: $9eab5d375ba1bffd$var$contentStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lAFHW.LoomIcon), {
        appearance: "brand"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        color: "color.text",
        size: "large"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $9eab5d375ba1bffd$var$i18n.spotlightTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $9eab5d375ba1bffd$var$i18n.spotlightDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
        href: $9eab5d375ba1bffd$var$loomHref,
        target: "_blank",
        onClick: ()=>onStartRecording()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $9eab5d375ba1bffd$var$i18n.startRecording))))));
};
const $9eab5d375ba1bffd$export$edf3ca4196271bf8 = ()=>{
    const [{ isHidden: isHidden, pageSourceType: pageSourceType }, { onCloseSpotlight: onCloseSpotlight }] = (0, $dlxup.useAutomatedMeetingNotesSpotlight)();
    return isHidden ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($9eab5d375ba1bffd$export$b30968b1b90f389b, {
        onClose: onCloseSpotlight,
        pageSource: pageSourceType
    });
};

});
parcelRegister("5U2Bi", function(module, exports) {
module.exports = new URL("Thumbnail.d9124b79.svg", import.meta.url).toString();

});

parcelRegister("dlxup", function(module, exports) {

$parcel$export(module.exports, "AutomatedMeetingNotesSpotlightPageSource", () => $1b3a4b2928c8d164$export$f79d013bbb911089);
$parcel$export(module.exports, "useAutomatedMeetingNotesSpotlight", () => $1b3a4b2928c8d164$export$8259bebea3663b57);
$parcel$export(module.exports, "useAutomatedMeetingNotesSpotlightActions", () => $1b3a4b2928c8d164$export$89ae432803231630);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");

var $gKr8t = parcelRequire("gKr8t");

var $ge2sX = parcelRequire("ge2sX");

var $04e9M = parcelRequire("04e9M");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $6mYmv = parcelRequire("6mYmv");
var $1b3a4b2928c8d164$export$f79d013bbb911089 = /*#__PURE__*/ function(AutomatedMeetingNotesSpotlightPageSource) {
    AutomatedMeetingNotesSpotlightPageSource["MEETING_NOTES_TEMPLATE"] = "MEETING_NOTES_TEMPLATE";
    AutomatedMeetingNotesSpotlightPageSource["TEAM_CALENDAR"] = "TEAM_CALENDAR";
    AutomatedMeetingNotesSpotlightPageSource["PERSONAL_CALENDAR"] = "PERSONAL_CALENDAR";
    AutomatedMeetingNotesSpotlightPageSource["AMN_VIEW_PAGE"] = "AMN_VIEW_PAGE";
    return AutomatedMeetingNotesSpotlightPageSource;
}({});
const $1b3a4b2928c8d164$export$734f885fe7403cc8 = {
    onOpenSpotlightIfNeeded: (pageSourceType)=>async ({ setState: setState, getState: getState })=>{
            const numberTimesShown = Number((0, $e9zUf.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).AMN_SPOTLIGHT_KEY) || 0);
            if (numberTimesShown >= 2) return;
            // eslint-disable-next-line prefer-const
            let { meetingNotesAvailable: meetingNotesAvailable, meetingNotesEnabled: meetingNotesEnabled, isHidden: isHidden } = getState();
            if (meetingNotesAvailable === undefined || meetingNotesEnabled === undefined) {
                const meetingSettings = await $1b3a4b2928c8d164$var$getMeetingNotesSettings();
                meetingNotesAvailable = meetingSettings.meetingNotesAvailable;
                meetingNotesEnabled = meetingSettings.meetingNotesEnabled;
            }
            const shouldShowSpotlight = meetingNotesAvailable && !meetingNotesEnabled && isHidden;
            if (shouldShowSpotlight) {
                setState({
                    isHidden: false,
                    pageSourceType: pageSourceType
                });
                (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).AMN_SPOTLIGHT_KEY, numberTimesShown + 1);
                (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                    client.sendScreenEvent({
                        name: 'meetingNotesSpotlight',
                        attributes: {
                            nudgeSource: pageSourceType
                        }
                    });
                });
            }
        },
    onCloseSpotlight: ()=>async ({ setState: setState })=>{
            setState({
                isHidden: true
            });
        }
};
const $1b3a4b2928c8d164$var$Store = (0, $4ZoIm.createStore)({
    initialState: {
        isHidden: true,
        pageSourceType: null
    },
    actions: $1b3a4b2928c8d164$export$734f885fe7403cc8,
    name: 'automatedMeetingNotesSpotlightState'
});
const $1b3a4b2928c8d164$export$8259bebea3663b57 = (0, $iFWZA.createHook)($1b3a4b2928c8d164$var$Store);
const $1b3a4b2928c8d164$export$89ae432803231630 = (0, $iFWZA.createActionsHook)($1b3a4b2928c8d164$var$Store);
const $1b3a4b2928c8d164$var$getMeetingNotesSettings = async ()=>{
    const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
    const { data: data, errors: errors } = await (0, $gKr8t.getAGGClient)().query({
        query: (0, $6mYmv.MeetingNotesSettingsQuery),
        variables: {
            siteId: cloudId
        }
    });
    if (errors) throw errors;
    return data.loom_settings;
};

});
parcelRegister("6mYmv", function(module, exports) {

$parcel$export(module.exports, "MeetingNotesSettingsQuery", () => $a5045d316cf57d7d$export$8dd57231676e4d77);

var $d2LG0 = parcelRequire("d2LG0");
const $a5045d316cf57d7d$export$8dd57231676e4d77 = (0, $d2LG0.default)`query MeetingNotesSettingsQuery($siteId:ID!){loom_settings(siteId:$siteId){meetingNotesAvailable meetingNotesEnabled}}`;

});



parcelRegister("ddOcd", function(module, exports) {

$parcel$export(module.exports, "MainLayoutComponent", () => $4e0d0b830c02a893$export$375787c0d3c11135);
/* MainLayoutComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $ipPpS = parcelRequire("ipPpS");

var $gz8ZY = parcelRequire("gz8ZY");

var $3PXtn = parcelRequire("3PXtn");

var $dIouf = parcelRequire("dIouf");

var $kLzei = parcelRequire("kLzei");

var $eSLr0 = parcelRequire("eSLr0");

var $hDG7z = parcelRequire("hDG7z");

var $hsPwY = parcelRequire("hsPwY");
var $9Z1sw = parcelRequire("9Z1sw");

var $fTjAG = parcelRequire("fTjAG");

var $2DRHd = parcelRequire("2DRHd");

var $kVysQ = parcelRequire("kVysQ");
var $4NX9d = parcelRequire("4NX9d");

var $jln20 = parcelRequire("jln20");

var $3jwuS = parcelRequire("3jwuS");

var $9wGTI = parcelRequire("9wGTI");

var $6M71K = parcelRequire("6M71K");

var $e4o8D = parcelRequire("e4o8D");

var $8zMP3 = parcelRequire("8zMP3");

var $1NBp8 = parcelRequire("1NBp8");

var $eYvuU = parcelRequire("eYvuU");

var $1EzU0 = parcelRequire("1EzU0");

var $1kZY5 = parcelRequire("1kZY5");

var $gU0tm = parcelRequire("gU0tm");
const $4e0d0b830c02a893$var$webPanelWrapperStyles = {
    showPanel: "_1e0c1ule",
    hidePanel: "_1e0cglyw"
};
const $4e0d0b830c02a893$var$contentBodyWrapperStyles = null;
const $4e0d0b830c02a893$var$fixedWebPanelSpacerStyles = null;
const $4e0d0b830c02a893$var$fixedForgeBannerSpacerStyles = null;
const $4e0d0b830c02a893$var$mainContentContainerStyles = {
    default: "_v5641fl4 _2lx2vrvc _1n261g80 _1bsb15jn _18u0v77o _1s6jaq80",
    enableRightSidebar: "_1bsbsul6",
    nav4Enabled: "_1bsb1osq _18u0ze3t",
    addMinWidth: "_1ul9cv93"
};
const $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles = {
    default: "_1e0cglyw _1pby1ial _1bsb1osq _kqsw1n9t _bfhkvuon _1ltv1d4h _p12f18ua",
    showPanel: "_1e0c1ule",
    isFullWidth: "_1ltvidpf _p12fglyw"
};
const $4e0d0b830c02a893$var$ContentBodyCompiled = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11q7vuon _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _s7n4jp4b _1tke1wug _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles
const $4e0d0b830c02a893$var$ContentBodyWithContainerTypeCompiled = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11q7vuon _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _s7n4jp4b _1tke1wug _1bsb1osq _7cca15wb _1f381gzp",
            __cmplp.className
        ])
    });
});
const $4e0d0b830c02a893$export$375787c0d3c11135 = ({ navView: navView, enableNavigation: enableNavigation = true, disableMinWidth: disableMinWidth, screen: screen, editorPreloader: editorPreloader, isViewPage: isViewPage = false, isEdit: isEdit, children: children })=>{
    const [preloader, setPreloader] = (0, $gwFzn.useState)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const isPdfExport = typeof window !== 'undefined' && (0, $1NBp8.PDF_EXPORT_PAGE).match(window.location.pathname);
    const ommitComponentsNotNeededForPdfExport = isPdfExport && (0, $9wGTI.fg)('confluence_fe_omit_unneeded_comps_for_pdf_export');
    const { shouldShowATLGeneralWebPanel: shouldShowATLGeneralWebPanel, isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed, fixedATLGeneralWebPanelRef: fixedATLGeneralWebPanelRef, isFullWidth: isFullWidth, shouldHidePanels: shouldHidePanels } = (0, $hsPwY.useATLGeneralWebPanelObserver)(isViewPage);
    const { isForgePageBannerFixed: isForgePageBannerFixed, fixedForgePageBannerRef: fixedForgePageBannerRef, isForgePageBannerFullWidth: isForgePageBannerFullWidth, shouldHideForgePageBanner: shouldHideForgePageBanner } = (0, $fTjAG.useForgePageBannerObserver)(isViewPage, isNav4Enabled, isEdit);
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const [enableRightSidebarCSS, setEnableRightSidebarCSS] = (0, $gwFzn.useState)(false);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const enableBreakoutScript = renderServerPlaceholder && (0, $9wGTI.fg)('confluence_preset_atl_general_height');
    const topElementStyle = {};
    if (screen) for(const key in screen){
        if (screen.hasOwnProperty(key)) {
            if (key.startsWith('background')) topElementStyle[key] = screen[key];
        }
    }
    (0, $gwFzn.useEffect)(()=>{
        if (rightSidebarContext.getCurrent()) setEnableRightSidebarCSS(true);
    }, [
        rightSidebarContext
    ]);
    (0, $gwFzn.useEffect)(()=>{
        setEditorPreloader(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const setEditorPreloader = async ()=>{
        if (editorPreloader) {
            const preloader = await editorPreloader();
            setPreloader(preloader);
        }
    };
    const CompiledWebPanel = isATLGeneralWebPanelFixed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        ref: fixedATLGeneralWebPanelRef,
        "data-test-id": "fixed-atl-general-wrapper",
        className: (0, $35pXk.default)([
            $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['default'],
            !shouldHidePanels && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['showPanel'],
            !isNav4Enabled && isFullWidth && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['isFullWidth']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: "cache-first"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_4t3i1wzo"
        ])
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-test-id": "atl-general-wrapper",
        className: (0, $35pXk.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHidePanels && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: "cache-first"
    }));
    const CompiledPageBannerForgeApp = isForgePageBannerFixed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-test-id": "fixed-forge-page-banner-wrapper-compiled",
        ref: fixedForgePageBannerRef,
        className: (0, $35pXk.default)([
            $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['default'],
            !shouldHideForgePageBanner && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['showPanel'],
            isForgePageBannerFullWidth && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['isFullWidth']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1kZY5.RenderPageBannerForgeApps), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_4t3irbkl"
        ])
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHideForgePageBanner && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1kZY5.RenderPageBannerForgeApps), null));
    const EmotionWebPanel = isATLGeneralWebPanelFixed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gU0tm.FixedWebPanelWrapper), {
        ref: fixedATLGeneralWebPanelRef,
        isFullWidth: isFullWidth,
        isNav4Enabled: isNav4Enabled,
        showPanel: !shouldHidePanels,
        "data-test-id": "fixed-atl-general-wrapper",
        "data-connect-container": "fixed-atl-general-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: "cache-first"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gU0tm.FixedWebPanelSpacer), null), enableBreakoutScript && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1EzU0.BreakoutSSRInlineScript), {
        noOpSSRInlineScript: renderServerPlaceholder
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gU0tm.WebPanelWrapper), {
        showPanel: !shouldHidePanels,
        "data-test-id": "atl-general-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: "cache-first"
    }));
    const EmotionPageBannerForgeApp = isForgePageBannerFixed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gU0tm.FixedWebPanelWrapper), {
        "data-test-id": "fixed-forge-page-banner-wrapper-emotion",
        isFullWidth: isForgePageBannerFullWidth,
        isNav4Enabled: isNav4Enabled,
        showPanel: !shouldHideForgePageBanner,
        ref: fixedForgePageBannerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1kZY5.RenderPageBannerForgeApps), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gU0tm.FixedForgeBannerSpacer), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gU0tm.WebPanelWrapper), {
        showPanel: !shouldHideForgePageBanner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1kZY5.RenderPageBannerForgeApps), null));
    const AtlGeneralWebPanel = (0, $9wGTI.fg)('confluence_frontend_main_layout_compiled') ? CompiledWebPanel : EmotionWebPanel;
    const ForgePageBannerExtensionPoint = (0, $9wGTI.fg)('confluence_frontend_main_layout_compiled') ? CompiledPageBannerForgeApp : EmotionPageBannerForgeApp;
    const contentCompiled = children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        /*
         * Previously, this used to be a `<Global styles={[…]} />` from Emotion
         * But in the Compiled migration, there is no alternative and feels like the best path forward for now.
         */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $35pXk.default)([
            $4e0d0b830c02a893$var$mainContentContainerStyles['default'],
            enableRightSidebarCSS && $4e0d0b830c02a893$var$mainContentContainerStyles['enableRightSidebar'],
            !enableRightSidebarCSS && !(disableMinWidth || !enableNavigation) && $4e0d0b830c02a893$var$mainContentContainerStyles['addMinWidth'],
            isNav4Enabled && $4e0d0b830c02a893$var$mainContentContainerStyles['nav4Enabled'],
            $eYvuU.dialogStyle
        ]),
        "data-test-id": "confluence-main-content",
        "data-vc": "confluence-main-content-compiled"
    }, shouldShowATLGeneralWebPanel && !ommitComponentsNotNeededForPdfExport && AtlGeneralWebPanel, (0, $9wGTI.fg)('forge-ui-enable-confluence-page-banner') && ForgePageBannerExtensionPoint, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2DRHd.ReturnToMobile), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $3PXtn.BannerStateContainer)
        ]
    }, (bannerState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            className: (0, $35pXk.default)([
                "_16jlidpf _1o9zkb7n _i0dl1wug _19pkidpf _vchhusvi _kqswh2mm _1bsb1osq _1e0c1txw"
            ])
        }, (0, $9wGTI.fg)('confluence_frontend_content_body_container') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4e0d0b830c02a893$var$ContentBodyWithContainerTypeCompiled, {
            "data-test-id": "content-body",
            "data-vc": "content-body-with-container-type-compiled",
            id: "content-body",
            bannerHeight: bannerState.getTotalHeight(),
            style: topElementStyle
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4e0d0b830c02a893$var$ContentBodyCompiled, {
            "data-test-id": "content-body",
            "data-vc": "content-body-compiled",
            id: "content-body",
            bannerHeight: bannerState.getTotalHeight(),
            style: topElementStyle
        }, children))), !isEdit && !isLivePage && !ommitComponentsNotNeededForPdfExport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-test-id": "atl-footer-wrapper",
        className: (0, $35pXk.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHidePanels && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_FOOTER)
    })), (0, $9wGTI.fg)('confluence_forge_background_script') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1kZY5.RenderBackgroundScriptApps), null)))) : null;
    const contentEmotion = children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gU0tm.MainContentContainer), {
        isEnableRightSidebarEnabled: enableRightSidebarCSS,
        isNav4Enabled: (0, $9wGTI.fg)('confluence_nav_4'),
        disableMinWidth: disableMinWidth || !enableNavigation,
        "data-test-id": "confluence-main-content",
        "data-vc": "confluence-main-content-emotion"
    }, shouldShowATLGeneralWebPanel && AtlGeneralWebPanel, (0, $9wGTI.fg)('forge-ui-enable-confluence-page-banner') && ForgePageBannerExtensionPoint, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2DRHd.ReturnToMobile), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $3PXtn.BannerStateContainer)
        ]
    }, (bannerState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gU0tm.ContentBodyWrapper), null, (0, $9wGTI.fg)('confluence_frontend_content_body_container') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gU0tm.ContentBodyWithContainerType), {
            "data-test-id": "content-body",
            "data-vc": "content-body-with-container-type-emotion",
            id: "content-body",
            topElementStyle: topElementStyle,
            bannerHeight: bannerState.getTotalHeight()
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gU0tm.ContentBody), {
            "data-test-id": "content-body",
            "data-vc": "content-body-emotion",
            id: "content-body",
            topElementStyle: topElementStyle,
            bannerHeight: bannerState.getTotalHeight()
        }, children))), !isEdit && !isLivePage && /* Hides the panel's UI in non-page content types but keeps the content (vendors often use background scripts for this footer extension point) */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gU0tm.WebPanelWrapper), {
        "data-test-id": "atl-footer-wrapper",
        showPanel: !shouldHidePanels
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_FOOTER)
    }))), (0, $9wGTI.fg)('confluence_forge_background_script') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1kZY5.RenderBackgroundScriptApps), null))) : null;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
        dataFetcherName: "main-content"
    }, (0, $9wGTI.fg)('confluence_frontend_main_layout_compiled') ? contentCompiled : contentEmotion);
    const mainLayoutBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, enableNavigation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hDG7z.PageLayout), {
        editorPreloader: preloader,
        view: navView
    }, content) : content, !(0, $9wGTI.fg)('confluence_frontend_main_layout_compiled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gU0tm.GlobalImagePreviewStyling), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4NX9d.PerformanceEnd), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_mainLayout)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, (0, $9wGTI.fg)('confluence_smart_card_provider_preview_panel') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6M71K.ConfluenceSmartCardProvider), (0, $kLzei.getSmartCardRenderers)(), mainLayoutBody) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, mainLayoutBody));
};

});
parcelRegister("hDG7z", function(module, exports) {

$parcel$export(module.exports, "PageLayout", () => $c8aadc7c03a52230$export$6d1402fb58384e4f);
//this file switches between Nav 3 and Nav 4 page-layout components. When Nav 4 is at 100% this file can simply be deleted and index can export nav 4 directly instead

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $gz8ZY = parcelRequire("gz8ZY");

const $c8aadc7c03a52230$var$Nav3Layout = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "RPrst",
    name: "Nav3Layout",
    loader: async ()=>(await (parcelRequire("22UM6"))).PageLayout
});

const $c8aadc7c03a52230$var$Nav4Layout = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "F4Zdx",
    name: "Nav4Layout",
    loader: async ()=>(await (parcelRequire("b6nVQ"))).PageLayout
});
const $c8aadc7c03a52230$export$6d1402fb58384e4f = (props)=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    return isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c8aadc7c03a52230$var$Nav4Layout, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c8aadc7c03a52230$var$Nav3Layout, props);
};

});
parcelRegister("22UM6", function(module, exports) {

let $17d7cef67438ef7d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $17d7cef67438ef7d$var$load("gw8XV"),
    $17d7cef67438ef7d$var$load("z47FH"),
    $17d7cef67438ef7d$var$load("6qplU"),
    $17d7cef67438ef7d$var$load("jLbdY"),
    $17d7cef67438ef7d$var$load("9ZTsO"),
    $17d7cef67438ef7d$var$load("h9ALM"),
    $17d7cef67438ef7d$var$load("eI3Gm"),
    $17d7cef67438ef7d$var$load("7ZpqL"),
    $17d7cef67438ef7d$var$load("cZgEZ"),
    $17d7cef67438ef7d$var$load("2F69B"),
    $17d7cef67438ef7d$var$load("6W2BP"),
    $17d7cef67438ef7d$var$load("fwbht"),
    $17d7cef67438ef7d$var$load("7VwsU"),
    $17d7cef67438ef7d$var$load("fsZ6i"),
    $17d7cef67438ef7d$var$load("c6MKV"),
    $17d7cef67438ef7d$var$load("ffEVr"),
    $17d7cef67438ef7d$var$load("aZinD"),
    $17d7cef67438ef7d$var$load("6gqpV"),
    $17d7cef67438ef7d$var$load("69mq0"),
    $17d7cef67438ef7d$var$load("bbnaa"),
    $17d7cef67438ef7d$var$load("joJy8"),
    $17d7cef67438ef7d$var$load("aHE9G"),
    $17d7cef67438ef7d$var$load("a6eof")
]).then(()=>parcelRequire('2xpE0'));

});

parcelRegister("b6nVQ", function(module, exports) {

let $8152d1a4f1a9c7ed$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $8152d1a4f1a9c7ed$var$load("gw8XV"),
    $8152d1a4f1a9c7ed$var$load("bFqd8"),
    $8152d1a4f1a9c7ed$var$load("6ejFK"),
    $8152d1a4f1a9c7ed$var$load("aEF5t"),
    $8152d1a4f1a9c7ed$var$load("eYcaz"),
    $8152d1a4f1a9c7ed$var$load("y4DZg"),
    $8152d1a4f1a9c7ed$var$load("jLbdY"),
    $8152d1a4f1a9c7ed$var$load("jCNLy"),
    $8152d1a4f1a9c7ed$var$load("5epKi"),
    $8152d1a4f1a9c7ed$var$load("kq5g1"),
    $8152d1a4f1a9c7ed$var$load("4zTgj"),
    $8152d1a4f1a9c7ed$var$load("9ZTsO"),
    $8152d1a4f1a9c7ed$var$load("g1nDL"),
    $8152d1a4f1a9c7ed$var$load("h9ALM"),
    $8152d1a4f1a9c7ed$var$load("7ZpqL"),
    $8152d1a4f1a9c7ed$var$load("cZgEZ"),
    $8152d1a4f1a9c7ed$var$load("6W2BP"),
    $8152d1a4f1a9c7ed$var$load("iAspJ"),
    $8152d1a4f1a9c7ed$var$load("gCIfF"),
    $8152d1a4f1a9c7ed$var$load("gLxW3"),
    $8152d1a4f1a9c7ed$var$load("ftJgg"),
    $8152d1a4f1a9c7ed$var$load("2tJdo"),
    $8152d1a4f1a9c7ed$var$load("fwbht"),
    $8152d1a4f1a9c7ed$var$load("7lGj4"),
    $8152d1a4f1a9c7ed$var$load("19XET"),
    $8152d1a4f1a9c7ed$var$load("7VwsU"),
    $8152d1a4f1a9c7ed$var$load("fsZ6i"),
    $8152d1a4f1a9c7ed$var$load("hP2ev"),
    $8152d1a4f1a9c7ed$var$load("6FRhD"),
    $8152d1a4f1a9c7ed$var$load("dTsOE"),
    $8152d1a4f1a9c7ed$var$load("jWyan"),
    $8152d1a4f1a9c7ed$var$load("kjZZD"),
    $8152d1a4f1a9c7ed$var$load("8DoxJ"),
    $8152d1a4f1a9c7ed$var$load("fqZPY"),
    $8152d1a4f1a9c7ed$var$load("9ybBP"),
    $8152d1a4f1a9c7ed$var$load("aGZFn"),
    $8152d1a4f1a9c7ed$var$load("2oVPY"),
    $8152d1a4f1a9c7ed$var$load("lFp1i"),
    $8152d1a4f1a9c7ed$var$load("dLkMK"),
    $8152d1a4f1a9c7ed$var$load("d4MuV"),
    $8152d1a4f1a9c7ed$var$load("i73Fi"),
    $8152d1a4f1a9c7ed$var$load("4Bp5z"),
    $8152d1a4f1a9c7ed$var$load("6gqpV"),
    $8152d1a4f1a9c7ed$var$load("69mq0"),
    $8152d1a4f1a9c7ed$var$load("bbnaa"),
    $8152d1a4f1a9c7ed$var$load("aZinD"),
    $8152d1a4f1a9c7ed$var$load("cyGuT"),
    $8152d1a4f1a9c7ed$var$load("knC27"),
    $8152d1a4f1a9c7ed$var$load("6qah4"),
    $8152d1a4f1a9c7ed$var$load("ffEVr"),
    $8152d1a4f1a9c7ed$var$load("aKcQg"),
    $8152d1a4f1a9c7ed$var$load("gKFP2"),
    $8152d1a4f1a9c7ed$var$load("c6MKV"),
    $8152d1a4f1a9c7ed$var$load("joJy8"),
    $8152d1a4f1a9c7ed$var$load("aHE9G"),
    $8152d1a4f1a9c7ed$var$load("z47FH"),
    $8152d1a4f1a9c7ed$var$load("6qplU"),
    $8152d1a4f1a9c7ed$var$load("gmHzx")
]).then(()=>parcelRequire('48Eol'));

});


parcelRegister("hsPwY", function(module, exports) {

$parcel$export(module.exports, "useATLGeneralWebPanelObserver", () => $9739cc17e95eb22c$export$8610b0674aff537e);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $2jjxD = parcelRequire("2jjxD");

var $eSLr0 = parcelRequire("eSLr0");

var $3jwuS = parcelRequire("3jwuS");

var $ep3mz = parcelRequire("ep3mz");

var $cEgMD = parcelRequire("cEgMD");

var $dPJCf = parcelRequire("dPJCf");

var $11b8R = parcelRequire("11b8R");

var $9wGTI = parcelRequire("9wGTI");

var $PrCoC = parcelRequire("PrCoC");
var $e4o8D = parcelRequire("e4o8D");

var $6mKj3 = parcelRequire("6mKj3");

var $dS3n9 = parcelRequire("dS3n9");

var $kXLBu = parcelRequire("kXLBu");
const $9739cc17e95eb22c$export$8610b0674aff537e = (isViewPage)=>{
    const [{ contentId: contentId, spaceKey: spaceKey, contentType: contentType }] = (0, $ep3mz.usePageState)();
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)({
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: 'cache-first',
        spaceKey: spaceKey,
        contentId: contentId
    });
    const fixedATLGeneralWebPanelRef = (0, $gwFzn.useRef)(null);
    const allAppsLoaded = (0, $gwFzn.useRef)(false);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    // For Nav 3, we expand atl.general panel to full width when the side nav is not present. This is the case for
    // company hub and when url has mode=global, such as on custom homepage
    // For Nav 4, the side nav is always present, so we have an additional check on isNav4Enabled in FixedWebPanelWrapper
    const isFullWidth = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || routeDataRef.current?.queryParams?.mode === 'global';
    const shouldShowATLGeneralWebPanel = panels.length > 0;
    if (shouldShowATLGeneralWebPanel) {
        (0, $PrCoC.superbatchJSRecorder).includeConnectWebResources();
        (0, $PrCoC.superbatchCSSRecorder).includeConnectWebResources();
    }
    // Determines if panels should not display a UI element and only allow for the support of scripts and analytics
    const shouldHidePanels = !(0, $11b8R.isPageOrBlogPost)(contentType) && contentType;
    // If the other conditions for a fixed web panel are true, check whether the space is themed
    // The web panel should not be fixed for themed spaces since they do not have a fixed page header
    const canFixATLGeneralWebPanel = shouldShowATLGeneralWebPanel && isViewPage && !isLivePage;
    const { data: data } = (0, $diswb.useQuery)((0, $d2LG0.default)`query useATLGeneralWebPanelObserverSpaceThemeQuery($spaceKey:String){space(key:$spaceKey){id theme{themeKey}}}`, {
        skip: !canFixATLGeneralWebPanel,
        variables: {
            spaceKey: spaceKey
        }
    });
    const isATLGeneralWebPanelFixed = canFixATLGeneralWebPanel && data?.space?.theme === null;
    // ResizeObserver is needed because the height of web panel items can change at any time
    const resizeObserver = (0, $gwFzn.useMemo)(()=>{
        if (!renderServerPlaceholder) {
            if ((0, $9wGTI.fg)('confluence_preset_atl_general_height')) {
                const callback = (0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))(([entry])=>{
                    if (entry) {
                        // Remove each connect app preset dimension until all apps are loaded
                        if (!allAppsLoaded.current) allAppsLoaded.current = !!(0, $kXLBu.removeConnectAppsWrapperDimension)(entry.target);
                        // Only reset container height after all connect apps are loaded,
                        // to prevent layout shift jumping up and down
                        if (allAppsLoaded.current) {
                            document.documentElement.style.setProperty('--atl-general-webpanel-height', `${entry.target.clientHeight}px`);
                            const detail = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                                detail: {
                                    height: entry.target.clientHeight
                                }
                            } : undefined;
                            document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail));
                        }
                    }
                }, 100);
                return new ResizeObserver(callback);
            }
            return new ResizeObserver(([entry])=>{
                if (entry) {
                    document.documentElement.style.setProperty('--atl-general-webpanel-height', `${entry.target.clientHeight}px`);
                    const detail = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                        detail: {
                            height: entry.target.clientHeight
                        }
                    } : undefined;
                    document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail));
                }
            });
        }
    }, [
        renderServerPlaceholder
    ]);
    (0, $gwFzn.useLayoutEffect)(()=>{
        const fixedATLGeneralWebPanel = fixedATLGeneralWebPanelRef.current;
        let appLoadTimeoutId;
        if (!renderServerPlaceholder && isATLGeneralWebPanelFixed && fixedATLGeneralWebPanel && (0, $9wGTI.fg)('confluence_preset_atl_general_height')) {
            // Handle content types that have web panel hidden, some content types have web panel hidden,
            // so it don't need to preset wrapper dimension.
            if (shouldHidePanels) {
                document.documentElement.style.setProperty('--atl-general-webpanel-height', `0px`);
                const detail = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                    detail: {
                        height: 0
                    }
                } : undefined;
                document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail));
            } else {
                const totalHeight = (0, $kXLBu.presetConnectAppsWrapperDimension)(fixedATLGeneralWebPanel, (0, $9wGTI.fg)('content_early_connect_iframe_initialization'));
                if (totalHeight) {
                    document.documentElement.style.setProperty('--atl-general-webpanel-height', `${totalHeight}px`);
                    const detail = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                        detail: {
                            height: totalHeight
                        }
                    } : undefined;
                    document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail));
                }
                // If after max wait time, connect apps are still not loaded, then remove preset dimensions
                appLoadTimeoutId = setTimeout(()=>{
                    if (!allAppsLoaded.current) {
                        (0, $kXLBu.removeConnectAppsWrapperDimension)(fixedATLGeneralWebPanel, true);
                        allAppsLoaded.current = true;
                        const connectAppsWrapperContainer = fixedATLGeneralWebPanel;
                        const containerHeight = connectAppsWrapperContainer?.clientHeight || 0;
                        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${containerHeight}px`);
                        const detail = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                            detail: {
                                height: containerHeight
                            }
                        } : undefined;
                        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail));
                    }
                }, (0, $kXLBu.MAX_WAIT_TIME_REMOVE_DIMENSION));
            }
        }
        if (isATLGeneralWebPanelFixed) fixedATLGeneralWebPanel && resizeObserver?.observe(fixedATLGeneralWebPanel);
        return ()=>{
            if (isATLGeneralWebPanelFixed) fixedATLGeneralWebPanel && resizeObserver?.unobserve(fixedATLGeneralWebPanel);
            if (appLoadTimeoutId) clearTimeout(appLoadTimeoutId);
        };
    }, [
        shouldShowATLGeneralWebPanel,
        isATLGeneralWebPanelFixed,
        resizeObserver,
        renderServerPlaceholder,
        shouldHidePanels
    ]);
    return {
        shouldShowATLGeneralWebPanel: shouldShowATLGeneralWebPanel,
        isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
        fixedATLGeneralWebPanelRef: fixedATLGeneralWebPanelRef,
        isCompanyHub: isCompanyHub,
        isFullWidth: isFullWidth,
        shouldHidePanels: shouldHidePanels
    };
};

});
parcelRegister("11b8R", function(module, exports) {

$parcel$export(module.exports, "isPageOrBlogPost", () => $edacfc52aca854e0$export$58b315702afd1f24);
const $edacfc52aca854e0$export$58b315702afd1f24 = (contentType)=>{
    return contentType === 'page' || contentType === 'blogpost';
};

});

parcelRegister("kXLBu", function(module, exports) {

$parcel$export(module.exports, "presetConnectAppsWrapperDimension", () => $bd143360dd0cf955$export$a25046a8b24b3fc6);
$parcel$export(module.exports, "removeConnectAppsWrapperDimension", () => $bd143360dd0cf955$export$a2ff9656ed51a40a);
$parcel$export(module.exports, "MAX_WAIT_TIME_REMOVE_DIMENSION", () => $bd143360dd0cf955$export$e36afaf5515aa43);
/**
 * Parse connect app scripts width and height, and preset connect apps dimention
 * before iframe gets injected, to avoid connect apps iframe causing layout shift
 * up and down multiple times
 *
 * Return total height of connect apps rendered in a location
 * @param container - The HTMLElement contains connect apps
 * @returns {number | undefined} - Returns total height of connect apps rendered in the container
 */ const $bd143360dd0cf955$export$a25046a8b24b3fc6 = (container, isEarlyInitIframe = false)=>{
    if (!document || !container) return;
    // Get all connect-app scripts at container, there can be multiple ones
    const allScripts = container.querySelectorAll('script.ap-iframe-body-script');
    if (!allScripts || allScripts.length === 0) return;
    // Total height of connect-app wrapper
    let totalHeight = 0;
    const parsePx = (matchedVal)=>{
        // Parse % or px
        let addPx = '';
        if (matchedVal.indexOf('%') === -1 && matchedVal.indexOf('px') === -1) addPx = 'px';
        return addPx;
    };
    allScripts.forEach((iframeScript)=>{
        // Get connect-app script html
        const scriptHtml = iframeScript?.innerHTML || '';
        if (scriptHtml) {
            const scriptWrapper = iframeScript.parentNode;
            // Extract connect-app height
            const matchedHeight = scriptHtml.match(/"h":\s*"(\d+(?:%|px)?)"/);
            const matchedHeightVal = matchedHeight?.[1];
            if (matchedHeightVal) {
                const matchedInt = parseInt(matchedHeightVal);
                // Add this connect-app height to total height
                if (typeof matchedInt === 'number') totalHeight += matchedInt;
                // Preset connect-app wrapper height before iframe is injected
                // NOTE: We don't want to set width or height, in case iframe is early initialized.
                if (!isEarlyInitIframe && scriptWrapper) scriptWrapper.style.height = matchedHeightVal + parsePx(matchedHeightVal);
            } else // If unable to extract height value, default to 0 during iframe loading to prevent jumping,
            // this will eventually be removed after connect apps are fully loaded.
            if (!isEarlyInitIframe) scriptWrapper.style.height = '0px';
            // Extract connect-app width
            const matchedWidth = scriptHtml.match(/"w":\s*"(\d+(?:%|px)?)"/);
            const matchedWidthVal = matchedWidth?.[1];
            if (matchedWidthVal) // Preset connect-app wrapper height before iframe is injected
            // NOTE: We don't want to set width or height, in case iframe is early initialized.
            {
                if (!isEarlyInitIframe && scriptWrapper) scriptWrapper.style.width = matchedWidthVal + parsePx(matchedWidthVal);
            }
        }
    });
    return totalHeight;
};
const $bd143360dd0cf955$export$a2ff9656ed51a40a = (container, timeout = false)=>{
    if (!document || !container) return;
    const appStatus = [];
    const allScripts = container.querySelectorAll('script.ap-iframe-body-script');
    if (!allScripts || allScripts.length === 0) return;
    // Remove each connect-app wrapper preset width and height after iframe loaded
    allScripts.forEach((iframeScript)=>{
        // Get connect-app parent
        const scriptWrapper = iframeScript.parentNode;
        const iframeLoaded = !!scriptWrapper.querySelector('iframe');
        const statusIndicator = scriptWrapper.querySelector('.ap-status-indicator');
        const timeoutIndicator = scriptWrapper.querySelector('.ap-load-timeout');
        const statusIndicatorHidden = statusIndicator?.style.display === 'none';
        // Check connect app loading status
        const isAppLoaded = iframeLoaded && (statusIndicatorHidden || timeoutIndicator);
        // Store each iframe's loading status
        appStatus.push(isAppLoaded);
        // If iframe is loaded, remove preset width and height
        if (isAppLoaded || timeout) {
            if (scriptWrapper?.style.height) scriptWrapper.style.height = '';
            if (scriptWrapper?.style.width) scriptWrapper.style.width = '';
        }
    });
    // Return if all connect apps are loaded
    return appStatus.every((status)=>status === true);
};
const $bd143360dd0cf955$export$e36afaf5515aa43 = 10000;

});


parcelRegister("9Z1sw", function(module, exports) {

$parcel$export(module.exports, "WebPanelLocation", () => $0aea74171df1eb15$export$2482f01f112556a);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $1eaCJ = parcelRequire("1eaCJ");
var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $ep3mz = parcelRequire("ep3mz");

var $c3Qwv = parcelRequire("c3Qwv");
var $7zgzO = parcelRequire("7zgzO");

var $eSLr0 = parcelRequire("eSLr0");

var $3QyBm = parcelRequire("3QyBm");

var $gTyTP = parcelRequire("gTyTP");

var $iqPSe = parcelRequire("iqPSe");

var $8pvtc = parcelRequire("8pvtc");
const $0aea74171df1eb15$export$2482f01f112556a = ({ location: location, style: style = {}, renderWhenLoading: renderWhenLoading, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', children: children, onCompleted: onCompleted })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { getQueryParams: getQueryParams } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isTwoPageTypesExperience: isTwoPageTypesExperience } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const EXPERIENCE_NAME_BY_LOCATION = {
        [(0, $eSLr0.ATL_FOOTER)]: (0, $irVI7.EXTENSION_POINT_HOME_FOOTER_EXPERIENCE),
        [(0, $eSLr0.ATL_GENERAL)]: (0, $irVI7.EXTENSION_POINT_HOME_HEADER_EXPERIENCE),
        [(0, $eSLr0.ATL_EDITOR_SAVEBAR)]: (0, $irVI7.EXTENSION_POINT_EDITOR_SAVEBAR_EXPERIENCE)
    };
    const experienceName = EXPERIENCE_NAME_BY_LOCATION[location] || null;
    (0, $gwFzn.useEffect)(()=>{
        if (experienceName) experienceTracker.start({
            name: experienceName
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const spaceIdentifier = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, 'spaceKey') || (0, $c3Qwv.getSingleParam)(queryParams, 'key');
    const contentIdentifier = contentId || (0, $c3Qwv.getSingleParam)(queryParams, 'pageId');
    // TODO: The task to remove this hack is captured in CFE-1873.
    // There's some weird scenario where the UI ends up with a space key of "byDraft" relating to the way tinymce
    // creates content. Given that it's tinymce specific, I'm applying this hack for now and we can remove it once we're
    // at 100% rollout for the Fabric editor.
    if (spaceIdentifier === 'byDraft') return null;
    const variables = contentIdentifier ? {
        contentId: contentIdentifier,
        location: location
    } : {
        spaceKey: spaceIdentifier,
        location: location
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j1Ss3.Query), {
        query: (0, $8pvtc.WebPanelLocationQuery),
        variables: variables,
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted
    }, ({ data: data, loading: loading, error: error })=>{
        // For transitions, loading and data is true
        if (loading && data) return null;
        if (!renderWhenLoading) {
            if (loading || error || !data) return null;
        }
        let panels = (data?.webPanels || []).filter((panel)=>panel);
        if (isTwoPageTypesExperience) panels = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, panels);
        // For panels that don't have a placeholder
        if (!renderWhenLoading && !panels.length) {
            if (experienceName) experienceTracker.succeed({
                name: experienceName
            });
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            style: style
        }, children ? children({
            panels: panels
        }) : panels.map((panel)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqPSe.WebPanel), {
                key: panel.completeKey,
                html: panel.html
            }))), experienceName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: experienceName
        }) : null);
    });
};

});
parcelRegister("iqPSe", function(module, exports) {

$parcel$export(module.exports, "WebPanel", () => $c50a10795e04dcb9$export$bbe14c99ac0820b3);
/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 
var $gwFzn = parcelRequire("gwFzn");

var $brpfO = parcelRequire("brpfO");

var $9wGTI = parcelRequire("9wGTI");
function $c50a10795e04dcb9$export$bbe14c99ac0820b3({ html: html }) {
    const containerRef = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useLayoutEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        // This is essentially a bug in React hydration. It is supposed to replace the element content with dangerouslySetInnerHTML
        // when server rendered output differs from client rendered output, but in reality it is keeping the original content.
        // Since it is keeping the original content, we need to manually check for the iframe and skip evalLegacyConnectInlineScripts
        // to avoid destroying / creating another iframe for connect webpanels.
        if (window?.__HYDRATABLE__ && (0, $9wGTI.fg)('content_early_connect_iframe_initialization')) {
            const scriptElement = container.querySelector('script.ap-iframe-body-script');
            if (scriptElement) {
                const scriptContent = scriptElement.textContent || '';
                const match = scriptContent.match(/"uniqueKey":"([^"]+)"/);
                if (match) {
                    const uniqueKey = match[1];
                    // Find iframe whose id contains the uniqueKey
                    const iframe = container.querySelector(`iframe[id*="${uniqueKey}"]`);
                    if (iframe) return;
                }
            }
        }
        (0, $brpfO.evalLegacyConnectInlineScripts)(container);
    }, [
        html
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        ref: containerRef,
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
}

});


parcelRegister("fTjAG", function(module, exports) {

$parcel$export(module.exports, "useForgePageBannerObserver", () => $062cf5e7a1742c3e$export$a6ca923c8089e1e8);

var $gwFzn = parcelRequire("gwFzn");

var $2jjxD = parcelRequire("2jjxD");

var $ep3mz = parcelRequire("ep3mz");

var $cEgMD = parcelRequire("cEgMD");

var $dPJCf = parcelRequire("dPJCf");

var $11b8R = parcelRequire("11b8R");

var $3jwuS = parcelRequire("3jwuS");

var $e4o8D = parcelRequire("e4o8D");

var $9wGTI = parcelRequire("9wGTI");

var $7Ndnw = parcelRequire("7Ndnw");

var $3b6WO = parcelRequire("3b6WO");

var $6mKj3 = parcelRequire("6mKj3");
const $062cf5e7a1742c3e$export$a6ca923c8089e1e8 = (isViewPage, isNav4Enabled, isEdit)=>{
    const [{ spaceKey: spaceKey, contentType: contentType }] = (0, $ep3mz.usePageState)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { extensions: extensions } = (0, $3b6WO.useExtensionList)({
        moduleType: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER)
    });
    // For Nav 3, we expand the banner to full width when the side nav is not present. This is the case for
    // company hub and when url has mode=global, such as on custom homepage.
    // For Nav 4, the side nav is always present - so the banner is never full width)
    const isSideNavPresent = isNav4Enabled || (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || routeDataRef.current?.queryParams?.mode === 'global';
    const { isForgePageBannerFixed: isForgePageBannerFixed, fixedForgePageBannerRef: fixedForgePageBannerRef } = $062cf5e7a1742c3e$var$useForgePageBannerObserverHelper(isViewPage, isLivePage, renderServerPlaceholder, extensions, isEdit);
    return {
        isForgePageBannerFixed: isForgePageBannerFixed,
        fixedForgePageBannerRef: fixedForgePageBannerRef,
        isForgePageBannerFullWidth: isSideNavPresent,
        shouldHideForgePageBanner: contentType && !(0, $11b8R.isPageOrBlogPost)(contentType)
    };
};
const $062cf5e7a1742c3e$var$useForgePageBannerObserverHelper = (isViewPage, isLivePage, renderServerPlaceholder, extensions, isEdit)=>{
    const fixedForgePageBannerRef = (0, $gwFzn.useRef)(null);
    const isForgePageBannerFixed = isViewPage && !isLivePage && !isEdit && extensions.length > 0; // extensions triggers a re-render
    const resizeObserver = (0, $gwFzn.useMemo)(()=>{
        if (!renderServerPlaceholder) return new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))(([entry])=>{
            if (entry) {
                document.documentElement.style.setProperty('--forge-page-banner-height', `${entry.target.clientHeight}px`);
                const detail = (0, $6mKj3.expVal)('confluence_pgxp_p2m_batch_1', 'isEnabled', false) ? {
                    detail: {
                        height: entry.target.clientHeight
                    }
                } : undefined;
                document.dispatchEvent(new CustomEvent('forgePageBannerHeightUpdated', detail));
            }
        }, 100));
    }, [
        renderServerPlaceholder
    ]);
    (0, $gwFzn.useLayoutEffect)(()=>{
        if ((0, $9wGTI.fg)('forge-ui-enable-confluence-page-banner')) {
            const fixedForgePageBanner = fixedForgePageBannerRef.current;
            if (isForgePageBannerFixed) fixedForgePageBanner && resizeObserver?.observe(fixedForgePageBanner);
            return ()=>{
                fixedForgePageBanner && resizeObserver?.unobserve(fixedForgePageBanner);
            };
        }
    }, [
        isForgePageBannerFixed,
        resizeObserver,
        renderServerPlaceholder
    ]);
    return {
        isForgePageBannerFixed: isForgePageBannerFixed,
        fixedForgePageBannerRef: fixedForgePageBannerRef
    };
};

});

parcelRegister("2DRHd", function(module, exports) {

$parcel$export(module.exports, "ReturnToMobile", () => $019e7af3f6f4f87e$export$4207093557acd0c0);

var $gwFzn = parcelRequire("gwFzn");

var $7zgzO = parcelRequire("7zgzO");

var $7D0B0 = parcelRequire("7D0B0");
class $019e7af3f6f4f87e$export$4207093557acd0c0 extends (0, $gwFzn.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ getQueryParams: getQueryParams, setQueryParams: setQueryParams })=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7D0B0.ReturnToMobileComponent), {
                getQueryParams: getQueryParams,
                setQueryParams: setQueryParams,
                ...this.props
            });
        });
    }
}

});
parcelRegister("7D0B0", function(module, exports) {

$parcel$export(module.exports, "ReturnToMobileComponent", () => $796a872a5806d472$export$5945f0cd1996f6fc);
/* ReturnToMobileComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $2Nwuj = parcelRequire("2Nwuj");

var $1DWH0 = parcelRequire("1DWH0");

var $9wGTI = parcelRequire("9wGTI");

var $68uaC = parcelRequire("68uaC");

var $8dwdz = parcelRequire("8dwdz");

var $jlIaF = parcelRequire("jlIaF");
function $796a872a5806d472$var$_defineProperty(e, r, t) {
    return (r = $796a872a5806d472$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $796a872a5806d472$var$_toPropertyKey(t) {
    var i = $796a872a5806d472$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $796a872a5806d472$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $796a872a5806d472$var$returnLinkContainer = null;
const $796a872a5806d472$export$5945f0cd1996f6fc = (0, $1DWH0.default)()(class ReturnToMobileComponent extends (0, $gwFzn.PureComponent) {
    componentDidMount() {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const { isSupportedUserAgent: isSupportedUserAgent } = this.state;
        if (isSupportedUserAgent && createAnalyticsEvent) {
            const analyticsData = {
                source: 'mobileWebView',
                action: 'visited',
                actionSubject: 'page'
            };
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: analyticsData
            }).fire();
        }
    }
    isDesktopSwitchRequired() {
        // Port from com.atlassian.confluence.mobile.MobileUtils#isDesktopSwitchRequired
        const { getQueryParams: getQueryParams } = this.props;
        const { desktop: desktop } = getQueryParams();
        return (0, $68uaC.Cookies).get('confluence.mobile.desktop.switch') === 'true' || desktop === 'true';
    }
    render() {
        const { isSupportedUserAgent: isSupportedUserAgent, isDesktopOverride: isDesktopOverride } = this.state; // Only show this if the user is on a mobile device and has explicitly chosen to show desktop
        if (isSupportedUserAgent && isDesktopOverride) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            className: (0, $35pXk.default)([
                "_1yt4pxbi _11q7m7j4 _y3gn1h6o"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            id: "return-to-mobile.nav.switch.to.mobile.text",
            defaultMessage: "You are viewing the desktop version of Confluence on a mobile supported device."
        }), ' ', (0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__enterprise-exp') ? // eslint-disable-next-line jsx-a11y/anchor-is-valid
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
            href: "#",
            onClick: this.onSwitchClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            id: "return-to-mobile.nav.switch.to.mobile.action",
            defaultMessage: "Switch to Confluence Mobile"
        })) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor, jsx-a11y/anchor-is-valid
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
            href: "#",
            onClick: this.onSwitchClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            id: "return-to-mobile.nav.switch.to.mobile.action",
            defaultMessage: "Switch to Confluence Mobile"
        })));
        return null;
    }
    constructor(...args){
        super(...args);
        $796a872a5806d472$var$_defineProperty(this, "state", {
            isSupportedUserAgent: (0, $8dwdz.isMobileUserAgent)(),
            // If the mobile SPA is handling mobile view, we need to check local storage
            // TODO: Remove the call to isDesktopSwitchRequired once mobile-plugin is dead
            isDesktopOverride: this.isDesktopSwitchRequired() || (0, $8dwdz.isDesktopOverrideActive)()
        });
        $796a872a5806d472$var$_defineProperty(this, "onSwitchClick", ()=>{
            const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = this.props; // If the backend filter has not set a cookie, we need to remove it from local storage (the new way)
            // TODO: Remove the call to isDesktopSwitchRequired once mobile-plugin is dead
            if (!this.isDesktopSwitchRequired()) (0, $8dwdz.deactivateDesktopOverride)();
            else // Otherwise, we need to remove the cookie
            (0, $68uaC.Cookies).remove('confluence.mobile.desktop.switch', {
                path: (0, $jlIaF.CONTEXT_PATH)
            });
            const queryParams = getQueryParams(); // remove the desktop=true request parameter if it is present
            if (queryParams.desktop === 'true') {
                queryParams.desktop = null; // setQueryParams removes null values
                setQueryParams(queryParams, true);
            } else window.location.reload();
        });
    }
});

});


parcelRegister("4NX9d", function(module, exports) {

$parcel$export(module.exports, "PerformanceEnd", () => $6182ff2f7ce21920$export$c7a09306845216e0);

var $fppBw = parcelRequire("fppBw");

var $gwFzn = parcelRequire("gwFzn");

var $9eE57 = parcelRequire("9eE57");
class $6182ff2f7ce21920$export$c7a09306845216e0 extends (0, $gwFzn.Component) {
    componentDidMount() {
        (0, $9eE57.perfMarkEnd)(this.props);
    }
    render() {
        return null;
    }
}
$6182ff2f7ce21920$export$c7a09306845216e0.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    details: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object,
    includeFeatureFlags: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool
};
$6182ff2f7ce21920$export$c7a09306845216e0.defaultProps = {
    subjectId: '',
    includeFeatureFlags: false
};

});

parcelRegister("8zMP3", function(module, exports) {

$parcel$export(module.exports, "SuspenseWithDataFetcher", () => $5cfe2edd168ef31e$export$553ede96e278ba94);

var $gwFzn = parcelRequire("gwFzn");

var $eS4vC = parcelRequire("eS4vC");
function $5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader({ dataFetcher: dataFetcher, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
}
function $5cfe2edd168ef31e$export$553ede96e278ba94({ dataFetcherName: dataFetcherName, fallback: fallback = null, children: children }) {
    if (window.__SSR_REACT_STREAMING__) {
        const dataFetcher = (0, $eS4vC.getDataFetcherForSuspense)(dataFetcherName);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Suspense), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader, {
            dataFetcher: dataFetcher
        }, children));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
}

});

parcelRegister("eYvuU", function(module, exports) {

$parcel$export(module.exports, "dialogStyle", () => $ae6f1a0e4a2e28fc$export$da31f8cf16ec20db, (v) => $ae6f1a0e4a2e28fc$export$da31f8cf16ec20db = v);
var $ae6f1a0e4a2e28fc$export$da31f8cf16ec20db;
$ae6f1a0e4a2e28fc$export$da31f8cf16ec20db = `OsGcuW_dialogStyle`;

});

parcelRegister("1EzU0", function(module, exports) {

$parcel$export(module.exports, "BreakoutSSRInlineScript", () => $bd51a8c87efeb5a5$export$cfc1361be0de4203);

var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $kXLBu = parcelRequire("kXLBu");
function $bd51a8c87efeb5a5$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
	 * Should only inline this script while SSR,
	 * not needed on the client side.
	 */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const context = $bd51a8c87efeb5a5$export$92859d13f30c883e();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("script", {
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: context
        }
    });
}
function $bd51a8c87efeb5a5$export$92859d13f30c883e() {
    return `
  (function(window){
		if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) {
			return;
		}
		${$bd51a8c87efeb5a5$export$47813c4121c8b4b3};
    (${$bd51a8c87efeb5a5$export$a125785b9fe77113.toString()})(breakoutConstsInner, ${(0, $9wGTI.fg)('content_early_connect_iframe_initialization')});
  })(window);
 `;
}
const $bd51a8c87efeb5a5$export$47813c4121c8b4b3 = `
	var breakoutConstsInner = {};
  breakoutConstsInner.presetConnectAppsWrapperDimension = ${(0, $kXLBu.presetConnectAppsWrapperDimension).toString()};
`;
function $bd51a8c87efeb5a5$export$a125785b9fe77113(breakoutConstsInner, isEarlyInitIframe = false) {
    const breakoutContainer = document.querySelector("[data-connect-container='fixed-atl-general-wrapper']");
    if (!breakoutContainer) return;
    const totalHeight = breakoutConstsInner?.presetConnectAppsWrapperDimension(breakoutContainer, isEarlyInitIframe);
    if (totalHeight) {
        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${totalHeight}px`);
        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated'));
        window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'] = totalHeight;
    }
}

});

parcelRegister("1kZY5", function(module, exports) {

$parcel$export(module.exports, "RenderBackgroundScriptApps", () => $b7830f7e8969acd1$export$f0362fceef532aae);
$parcel$export(module.exports, "RenderPageBannerForgeApps", () => $b7830f7e8969acd1$export$910fc80855ba5fda);
/* ForgeApps.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $dIouf = parcelRequire("dIouf");

var $irVI7 = parcelRequire("irVI7");
var $ln0hx = parcelRequire("ln0hx");

var $7Sm4c = parcelRequire("7Sm4c");

var $7QUD1 = parcelRequire("7QUD1");
var $7Ndnw = parcelRequire("7Ndnw");
var $8a9Dm = parcelRequire("8a9Dm");
var $hIaUw = parcelRequire("hIaUw");
var $dizL5 = parcelRequire("dizL5");

var $3jwuS = parcelRequire("3jwuS");

var $ep3mz = parcelRequire("ep3mz");

var $6uUjl = parcelRequire("6uUjl");
const $b7830f7e8969acd1$var$invisible = null;
const $b7830f7e8969acd1$export$afbabe4d2446fca2 = (forgeModules, loading, error)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ contentId: contentId, routeName: routeName, spaceKey: spaceAlias }] = (0, $ep3mz.usePageState)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    if (loading) return null;
    if (error) {
        if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
            error: error
        });
        return null;
    }
    return forgeModules.map((0, $dIouf.withErrorBoundary)({
        attribution: (0, $dIouf.Attribution).ECOSYSTEM
    })((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
            key: (0, $8a9Dm.getAppId)(app),
            attributes: {
                appId: (0, $8a9Dm.getAppId)(app)
            },
            attribution: (0, $dIouf.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            className: (0, $35pXk.default)([
                "_1e0cglyw"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.BACKGROUND_SCRIPT_APPS_FORGE_EXPERIENCE),
            id: (0, $8a9Dm.getAppId)(app)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7QUD1.BackgroundScriptForgeApp), {
            app: app,
            // Adding the pageRoute to the extensionData will allow the Forge app to re-render when the route changes
            extensionData: {
                type: (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
                ...contentId ? {
                    content: {
                        id: contentId,
                        type: (0, $hIaUw.getContentType)(routeName),
                        subtype: isLivePage ? 'live' : null
                    }
                } : {},
                ...spaceKey || spaceAlias ? {
                    space: {
                        id: spaceId,
                        key: spaceKey || spaceAlias
                    }
                } : {}
            }
        })))));
};
const $b7830f7e8969acd1$export$f0362fceef532aae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
        render: $b7830f7e8969acd1$export$afbabe4d2446fca2
    }); // This is exported solely for testing purposes
const $b7830f7e8969acd1$export$d778357d5618ef80 = (forgeModules, loading, error)=>{
    const [{ contentId: contentId, routeName: routeName, spaceKey: spaceAlias }] = (0, $ep3mz.usePageState)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    if (loading) return null;
    if (error) {
        if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
            error: error
        });
        return null;
    }
    return forgeModules.map((0, $dIouf.withErrorBoundary)({
        attribution: (0, $dIouf.Attribution).ECOSYSTEM
    })((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
            key: (0, $8a9Dm.getAppId)(app),
            attributes: {
                appId: (0, $8a9Dm.getAppId)(app)
            },
            attribution: (0, $dIouf.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7QUD1.PageBannerForgeApp), {
            app: app,
            extensionData: {
                type: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER),
                ...contentId ? {
                    content: {
                        id: contentId,
                        type: (0, $hIaUw.getContentType)(routeName),
                        subtype: isLivePage ? 'live' : null
                    }
                } : {},
                ...spaceKey || spaceAlias ? {
                    space: {
                        id: spaceId,
                        key: spaceKey || spaceAlias
                    }
                } : {}
            }
        }))));
};
const $b7830f7e8969acd1$export$910fc80855ba5fda = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER),
        render: $b7830f7e8969acd1$export$d778357d5618ef80
    });
};

});
parcelRegister("7QUD1", function(module, exports) {

$parcel$export(module.exports, "ByLineForgeApp", () => $02976f123c8f8e25$export$d2159b9f3f077903);
$parcel$export(module.exports, "ContentActionForgeApp", () => $02976f123c8f8e25$export$f900958ce7c4410f);
$parcel$export(module.exports, "ContextMenuForgeApp", () => $02976f123c8f8e25$export$79ed117743c6c2cf);
$parcel$export(module.exports, "GlobalPageForgeApp", () => $02976f123c8f8e25$export$83db8797814193a8);
$parcel$export(module.exports, "GlobalSettingsForgeApp", () => $02976f123c8f8e25$export$74528162c4c3828b);
$parcel$export(module.exports, "HomepageFeedForgeApp", () => $02976f123c8f8e25$export$c8291e2d6d6adbf2);
$parcel$export(module.exports, "SpaceSettingsForgeApp", () => $02976f123c8f8e25$export$e8858129e933f7e8);
$parcel$export(module.exports, "CustomContentForgeApp", () => $02976f123c8f8e25$export$578d0cbdb0ffa72e);
$parcel$export(module.exports, "BackgroundScriptForgeApp", () => $02976f123c8f8e25$export$40d4b5cfa6c18ea7);
$parcel$export(module.exports, "PageBannerForgeApp", () => $02976f123c8f8e25$export$c76787f94e0b1609);

var $jmjWc = parcelRequire("jmjWc");

const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("iQx6B"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("3YV6I"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("4DJ1Q"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("febxE"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("kItYq"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("leGhP"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("2Re5B"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("4xM6e"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("ennCH"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("1Uv2P"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("bKdcj"))).PageBannerForgeApp
});

});
parcelRegister("iQx6B", function(module, exports) {

let $db86c36805ddd9c2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $db86c36805ddd9c2$var$load("hf7yW"),
    $db86c36805ddd9c2$var$load("z47FH"),
    $db86c36805ddd9c2$var$load("6qplU"),
    $db86c36805ddd9c2$var$load("lnKog"),
    $db86c36805ddd9c2$var$load("gCIfF"),
    $db86c36805ddd9c2$var$load("2aE9V"),
    $db86c36805ddd9c2$var$load("iQ0Jm"),
    $db86c36805ddd9c2$var$load("gkmZg"),
    $db86c36805ddd9c2$var$load("h4Nf7"),
    $db86c36805ddd9c2$var$load("05d2I"),
    $db86c36805ddd9c2$var$load("fqZPY"),
    $db86c36805ddd9c2$var$load("9ybBP"),
    $db86c36805ddd9c2$var$load("7VwsU"),
    $db86c36805ddd9c2$var$load("fsZ6i"),
    $db86c36805ddd9c2$var$load("hP2ev"),
    $db86c36805ddd9c2$var$load("6FRhD"),
    $db86c36805ddd9c2$var$load("iIRyn"),
    $db86c36805ddd9c2$var$load("fYhfO"),
    $db86c36805ddd9c2$var$load("g9CVe"),
    $db86c36805ddd9c2$var$load("i73Fi"),
    $db86c36805ddd9c2$var$load("4Bp5z"),
    $db86c36805ddd9c2$var$load("6gqpV"),
    $db86c36805ddd9c2$var$load("aZinD"),
    $db86c36805ddd9c2$var$load("6qah4"),
    $db86c36805ddd9c2$var$load("ffEVr"),
    $db86c36805ddd9c2$var$load("joJy8"),
    $db86c36805ddd9c2$var$load("aHE9G"),
    $db86c36805ddd9c2$var$load("c6MKV"),
    $db86c36805ddd9c2$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("3YV6I", function(module, exports) {

let $2e6346068469db81$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2e6346068469db81$var$load("hf7yW"),
    $2e6346068469db81$var$load("z47FH"),
    $2e6346068469db81$var$load("6qplU"),
    $2e6346068469db81$var$load("lnKog"),
    $2e6346068469db81$var$load("gCIfF"),
    $2e6346068469db81$var$load("2aE9V"),
    $2e6346068469db81$var$load("iQ0Jm"),
    $2e6346068469db81$var$load("gkmZg"),
    $2e6346068469db81$var$load("h4Nf7"),
    $2e6346068469db81$var$load("05d2I"),
    $2e6346068469db81$var$load("fqZPY"),
    $2e6346068469db81$var$load("9ybBP"),
    $2e6346068469db81$var$load("7VwsU"),
    $2e6346068469db81$var$load("fsZ6i"),
    $2e6346068469db81$var$load("hP2ev"),
    $2e6346068469db81$var$load("6FRhD"),
    $2e6346068469db81$var$load("iIRyn"),
    $2e6346068469db81$var$load("fYhfO"),
    $2e6346068469db81$var$load("g9CVe"),
    $2e6346068469db81$var$load("i73Fi"),
    $2e6346068469db81$var$load("4Bp5z"),
    $2e6346068469db81$var$load("6gqpV"),
    $2e6346068469db81$var$load("aZinD"),
    $2e6346068469db81$var$load("6qah4"),
    $2e6346068469db81$var$load("ffEVr"),
    $2e6346068469db81$var$load("joJy8"),
    $2e6346068469db81$var$load("aHE9G"),
    $2e6346068469db81$var$load("c6MKV"),
    $2e6346068469db81$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("4DJ1Q", function(module, exports) {

let $360dbbb106c7e0e8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $360dbbb106c7e0e8$var$load("hf7yW"),
    $360dbbb106c7e0e8$var$load("z47FH"),
    $360dbbb106c7e0e8$var$load("6qplU"),
    $360dbbb106c7e0e8$var$load("lnKog"),
    $360dbbb106c7e0e8$var$load("gCIfF"),
    $360dbbb106c7e0e8$var$load("2aE9V"),
    $360dbbb106c7e0e8$var$load("iQ0Jm"),
    $360dbbb106c7e0e8$var$load("gkmZg"),
    $360dbbb106c7e0e8$var$load("h4Nf7"),
    $360dbbb106c7e0e8$var$load("05d2I"),
    $360dbbb106c7e0e8$var$load("fqZPY"),
    $360dbbb106c7e0e8$var$load("9ybBP"),
    $360dbbb106c7e0e8$var$load("7VwsU"),
    $360dbbb106c7e0e8$var$load("fsZ6i"),
    $360dbbb106c7e0e8$var$load("hP2ev"),
    $360dbbb106c7e0e8$var$load("6FRhD"),
    $360dbbb106c7e0e8$var$load("iIRyn"),
    $360dbbb106c7e0e8$var$load("fYhfO"),
    $360dbbb106c7e0e8$var$load("g9CVe"),
    $360dbbb106c7e0e8$var$load("i73Fi"),
    $360dbbb106c7e0e8$var$load("4Bp5z"),
    $360dbbb106c7e0e8$var$load("6gqpV"),
    $360dbbb106c7e0e8$var$load("aZinD"),
    $360dbbb106c7e0e8$var$load("6qah4"),
    $360dbbb106c7e0e8$var$load("ffEVr"),
    $360dbbb106c7e0e8$var$load("joJy8"),
    $360dbbb106c7e0e8$var$load("aHE9G"),
    $360dbbb106c7e0e8$var$load("c6MKV"),
    $360dbbb106c7e0e8$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("febxE", function(module, exports) {

let $b1611dc5c164cff9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $b1611dc5c164cff9$var$load("fqZPY"),
    $b1611dc5c164cff9$var$load("9ybBP"),
    $b1611dc5c164cff9$var$load("gCIfF"),
    $b1611dc5c164cff9$var$load("gkmZg"),
    $b1611dc5c164cff9$var$load("h4Nf7"),
    $b1611dc5c164cff9$var$load("7VwsU"),
    $b1611dc5c164cff9$var$load("fsZ6i"),
    $b1611dc5c164cff9$var$load("hP2ev"),
    $b1611dc5c164cff9$var$load("6FRhD"),
    $b1611dc5c164cff9$var$load("iIRyn"),
    $b1611dc5c164cff9$var$load("fYhfO"),
    $b1611dc5c164cff9$var$load("g9CVe"),
    $b1611dc5c164cff9$var$load("6qah4"),
    $b1611dc5c164cff9$var$load("i73Fi"),
    $b1611dc5c164cff9$var$load("4Bp5z"),
    $b1611dc5c164cff9$var$load("6gqpV"),
    $b1611dc5c164cff9$var$load("aZinD"),
    $b1611dc5c164cff9$var$load("ffEVr"),
    $b1611dc5c164cff9$var$load("joJy8"),
    $b1611dc5c164cff9$var$load("aHE9G"),
    $b1611dc5c164cff9$var$load("c6MKV"),
    $b1611dc5c164cff9$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("kItYq", function(module, exports) {

let $f14f2adc3e90f7b5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $f14f2adc3e90f7b5$var$load("fqZPY"),
    $f14f2adc3e90f7b5$var$load("9ybBP"),
    $f14f2adc3e90f7b5$var$load("gCIfF"),
    $f14f2adc3e90f7b5$var$load("gkmZg"),
    $f14f2adc3e90f7b5$var$load("h4Nf7"),
    $f14f2adc3e90f7b5$var$load("7VwsU"),
    $f14f2adc3e90f7b5$var$load("fsZ6i"),
    $f14f2adc3e90f7b5$var$load("hP2ev"),
    $f14f2adc3e90f7b5$var$load("6FRhD"),
    $f14f2adc3e90f7b5$var$load("iIRyn"),
    $f14f2adc3e90f7b5$var$load("fYhfO"),
    $f14f2adc3e90f7b5$var$load("g9CVe"),
    $f14f2adc3e90f7b5$var$load("6qah4"),
    $f14f2adc3e90f7b5$var$load("i73Fi"),
    $f14f2adc3e90f7b5$var$load("4Bp5z"),
    $f14f2adc3e90f7b5$var$load("6gqpV"),
    $f14f2adc3e90f7b5$var$load("aZinD"),
    $f14f2adc3e90f7b5$var$load("ffEVr"),
    $f14f2adc3e90f7b5$var$load("joJy8"),
    $f14f2adc3e90f7b5$var$load("aHE9G"),
    $f14f2adc3e90f7b5$var$load("c6MKV"),
    $f14f2adc3e90f7b5$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("leGhP", function(module, exports) {

let $f75bb4fea2d26301$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $f75bb4fea2d26301$var$load("fqZPY"),
    $f75bb4fea2d26301$var$load("9ybBP"),
    $f75bb4fea2d26301$var$load("z47FH"),
    $f75bb4fea2d26301$var$load("6qplU"),
    $f75bb4fea2d26301$var$load("lnKog"),
    $f75bb4fea2d26301$var$load("gCIfF"),
    $f75bb4fea2d26301$var$load("gkmZg"),
    $f75bb4fea2d26301$var$load("h4Nf7"),
    $f75bb4fea2d26301$var$load("7VwsU"),
    $f75bb4fea2d26301$var$load("fsZ6i"),
    $f75bb4fea2d26301$var$load("hP2ev"),
    $f75bb4fea2d26301$var$load("6FRhD"),
    $f75bb4fea2d26301$var$load("iIRyn"),
    $f75bb4fea2d26301$var$load("fYhfO"),
    $f75bb4fea2d26301$var$load("g9CVe"),
    $f75bb4fea2d26301$var$load("6qah4"),
    $f75bb4fea2d26301$var$load("i73Fi"),
    $f75bb4fea2d26301$var$load("4Bp5z"),
    $f75bb4fea2d26301$var$load("6gqpV"),
    $f75bb4fea2d26301$var$load("aZinD"),
    $f75bb4fea2d26301$var$load("ffEVr"),
    $f75bb4fea2d26301$var$load("joJy8"),
    $f75bb4fea2d26301$var$load("aHE9G"),
    $f75bb4fea2d26301$var$load("c6MKV"),
    $f75bb4fea2d26301$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("2Re5B", function(module, exports) {

let $214b75dccd6bad22$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $214b75dccd6bad22$var$load("8DoxJ"),
    $214b75dccd6bad22$var$load("z47FH"),
    $214b75dccd6bad22$var$load("6qplU"),
    $214b75dccd6bad22$var$load("lnKog"),
    $214b75dccd6bad22$var$load("gCIfF"),
    $214b75dccd6bad22$var$load("gkmZg"),
    $214b75dccd6bad22$var$load("h4Nf7"),
    $214b75dccd6bad22$var$load("fqZPY"),
    $214b75dccd6bad22$var$load("9ybBP"),
    $214b75dccd6bad22$var$load("7VwsU"),
    $214b75dccd6bad22$var$load("fsZ6i"),
    $214b75dccd6bad22$var$load("hP2ev"),
    $214b75dccd6bad22$var$load("6FRhD"),
    $214b75dccd6bad22$var$load("iIRyn"),
    $214b75dccd6bad22$var$load("fYhfO"),
    $214b75dccd6bad22$var$load("dTsOE"),
    $214b75dccd6bad22$var$load("g9CVe"),
    $214b75dccd6bad22$var$load("6qah4"),
    $214b75dccd6bad22$var$load("i73Fi"),
    $214b75dccd6bad22$var$load("4Bp5z"),
    $214b75dccd6bad22$var$load("6gqpV"),
    $214b75dccd6bad22$var$load("aZinD"),
    $214b75dccd6bad22$var$load("ffEVr"),
    $214b75dccd6bad22$var$load("joJy8"),
    $214b75dccd6bad22$var$load("aHE9G"),
    $214b75dccd6bad22$var$load("c6MKV"),
    $214b75dccd6bad22$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("4xM6e", function(module, exports) {

let $34ef8e0ab09c3b73$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $34ef8e0ab09c3b73$var$load("8DoxJ"),
    $34ef8e0ab09c3b73$var$load("z47FH"),
    $34ef8e0ab09c3b73$var$load("6qplU"),
    $34ef8e0ab09c3b73$var$load("lnKog"),
    $34ef8e0ab09c3b73$var$load("gCIfF"),
    $34ef8e0ab09c3b73$var$load("gkmZg"),
    $34ef8e0ab09c3b73$var$load("h4Nf7"),
    $34ef8e0ab09c3b73$var$load("fqZPY"),
    $34ef8e0ab09c3b73$var$load("9ybBP"),
    $34ef8e0ab09c3b73$var$load("7VwsU"),
    $34ef8e0ab09c3b73$var$load("fsZ6i"),
    $34ef8e0ab09c3b73$var$load("hP2ev"),
    $34ef8e0ab09c3b73$var$load("6FRhD"),
    $34ef8e0ab09c3b73$var$load("iIRyn"),
    $34ef8e0ab09c3b73$var$load("fYhfO"),
    $34ef8e0ab09c3b73$var$load("dTsOE"),
    $34ef8e0ab09c3b73$var$load("g9CVe"),
    $34ef8e0ab09c3b73$var$load("6qah4"),
    $34ef8e0ab09c3b73$var$load("i73Fi"),
    $34ef8e0ab09c3b73$var$load("4Bp5z"),
    $34ef8e0ab09c3b73$var$load("6gqpV"),
    $34ef8e0ab09c3b73$var$load("aZinD"),
    $34ef8e0ab09c3b73$var$load("ffEVr"),
    $34ef8e0ab09c3b73$var$load("joJy8"),
    $34ef8e0ab09c3b73$var$load("aHE9G"),
    $34ef8e0ab09c3b73$var$load("c6MKV"),
    $34ef8e0ab09c3b73$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("ennCH", function(module, exports) {

let $a77589bac1af7c3b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a77589bac1af7c3b$var$load("fqZPY"),
    $a77589bac1af7c3b$var$load("9ybBP"),
    $a77589bac1af7c3b$var$load("gCIfF"),
    $a77589bac1af7c3b$var$load("gkmZg"),
    $a77589bac1af7c3b$var$load("h4Nf7"),
    $a77589bac1af7c3b$var$load("7VwsU"),
    $a77589bac1af7c3b$var$load("fsZ6i"),
    $a77589bac1af7c3b$var$load("hP2ev"),
    $a77589bac1af7c3b$var$load("6FRhD"),
    $a77589bac1af7c3b$var$load("iIRyn"),
    $a77589bac1af7c3b$var$load("fYhfO"),
    $a77589bac1af7c3b$var$load("g9CVe"),
    $a77589bac1af7c3b$var$load("6qah4"),
    $a77589bac1af7c3b$var$load("i73Fi"),
    $a77589bac1af7c3b$var$load("4Bp5z"),
    $a77589bac1af7c3b$var$load("6gqpV"),
    $a77589bac1af7c3b$var$load("aZinD"),
    $a77589bac1af7c3b$var$load("ffEVr"),
    $a77589bac1af7c3b$var$load("joJy8"),
    $a77589bac1af7c3b$var$load("aHE9G"),
    $a77589bac1af7c3b$var$load("c6MKV"),
    $a77589bac1af7c3b$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("1Uv2P", function(module, exports) {

let $16431a3d1d1be007$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $16431a3d1d1be007$var$load("fqZPY"),
    $16431a3d1d1be007$var$load("9ybBP"),
    $16431a3d1d1be007$var$load("z47FH"),
    $16431a3d1d1be007$var$load("6qplU"),
    $16431a3d1d1be007$var$load("lnKog"),
    $16431a3d1d1be007$var$load("gCIfF"),
    $16431a3d1d1be007$var$load("gkmZg"),
    $16431a3d1d1be007$var$load("h4Nf7"),
    $16431a3d1d1be007$var$load("7VwsU"),
    $16431a3d1d1be007$var$load("fsZ6i"),
    $16431a3d1d1be007$var$load("hP2ev"),
    $16431a3d1d1be007$var$load("6FRhD"),
    $16431a3d1d1be007$var$load("iIRyn"),
    $16431a3d1d1be007$var$load("fYhfO"),
    $16431a3d1d1be007$var$load("g9CVe"),
    $16431a3d1d1be007$var$load("6qah4"),
    $16431a3d1d1be007$var$load("i73Fi"),
    $16431a3d1d1be007$var$load("4Bp5z"),
    $16431a3d1d1be007$var$load("6gqpV"),
    $16431a3d1d1be007$var$load("aZinD"),
    $16431a3d1d1be007$var$load("ffEVr"),
    $16431a3d1d1be007$var$load("joJy8"),
    $16431a3d1d1be007$var$load("aHE9G"),
    $16431a3d1d1be007$var$load("c6MKV"),
    $16431a3d1d1be007$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("bKdcj", function(module, exports) {

let $88ce3a5ddb68ac29$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $88ce3a5ddb68ac29$var$load("fqZPY"),
    $88ce3a5ddb68ac29$var$load("9ybBP"),
    $88ce3a5ddb68ac29$var$load("z47FH"),
    $88ce3a5ddb68ac29$var$load("6qplU"),
    $88ce3a5ddb68ac29$var$load("lnKog"),
    $88ce3a5ddb68ac29$var$load("gCIfF"),
    $88ce3a5ddb68ac29$var$load("gkmZg"),
    $88ce3a5ddb68ac29$var$load("h4Nf7"),
    $88ce3a5ddb68ac29$var$load("7VwsU"),
    $88ce3a5ddb68ac29$var$load("fsZ6i"),
    $88ce3a5ddb68ac29$var$load("hP2ev"),
    $88ce3a5ddb68ac29$var$load("6FRhD"),
    $88ce3a5ddb68ac29$var$load("iIRyn"),
    $88ce3a5ddb68ac29$var$load("fYhfO"),
    $88ce3a5ddb68ac29$var$load("g9CVe"),
    $88ce3a5ddb68ac29$var$load("6qah4"),
    $88ce3a5ddb68ac29$var$load("i73Fi"),
    $88ce3a5ddb68ac29$var$load("4Bp5z"),
    $88ce3a5ddb68ac29$var$load("6gqpV"),
    $88ce3a5ddb68ac29$var$load("aZinD"),
    $88ce3a5ddb68ac29$var$load("ffEVr"),
    $88ce3a5ddb68ac29$var$load("joJy8"),
    $88ce3a5ddb68ac29$var$load("aHE9G"),
    $88ce3a5ddb68ac29$var$load("c6MKV"),
    $88ce3a5ddb68ac29$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});


parcelRegister("8a9Dm", function(module, exports) {

$parcel$export(module.exports, "getAppId", () => $2cc1b73219e08564$export$fb2283f4a44fb53);
$parcel$export(module.exports, "getModuleKey", () => $2cc1b73219e08564$export$b17b21a48c0a3273);
$parcel$export(module.exports, "getCustomContentType", () => $2cc1b73219e08564$export$9eb690901638fb96);
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
const $2cc1b73219e08564$export$d3ac53161a36a310 = (forgeData)=>{
    const extensionContext = forgeData?.extensionContexts?.[0];
    if (!extensionContext) return [];
    if (extensionContext.hasOwnProperty('extensions')) return extensionContext.extensions;
    if (extensionContext.hasOwnProperty('extensionsByType')) return extensionContext.extensionsByType;
    return [];
};

});


parcelRegister("gU0tm", function(module, exports) {

$parcel$export(module.exports, "MainContentContainer", () => $370afc622ad38e0a$export$b5bdfcb4cafd161b);
$parcel$export(module.exports, "WebPanelWrapper", () => $370afc622ad38e0a$export$b84f0b2bc7887721);
$parcel$export(module.exports, "FixedWebPanelWrapper", () => $370afc622ad38e0a$export$4f2bba08a8d0c194);
$parcel$export(module.exports, "FixedWebPanelSpacer", () => $370afc622ad38e0a$export$f0626b55b8fc2197);
$parcel$export(module.exports, "FixedForgeBannerSpacer", () => $370afc622ad38e0a$export$2ac536f43b2b4617);
$parcel$export(module.exports, "ContentBodyWrapper", () => $370afc622ad38e0a$export$905efa1400f24d18);
$parcel$export(module.exports, "ContentBody", () => $370afc622ad38e0a$export$e7f760d742ca707f);
$parcel$export(module.exports, "ContentBodyWithContainerType", () => $370afc622ad38e0a$export$cc84a1cb61e1d196);
$parcel$export(module.exports, "GlobalImagePreviewStyling", () => $370afc622ad38e0a$export$33d0451cd012d019);

var $gwFzn = parcelRequire("gwFzn");

var $lhCUr = parcelRequire("lhCUr");

var $gwrgp = parcelRequire("gwrgp");
const $370afc622ad38e0a$export$b5bdfcb4cafd161b = (0, $gwrgp.default)("div", {
    target: "e6tglj30"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isEnableRightSidebarEnabled: isEnableRightSidebarEnabled, disableMinWidth: disableMinWidth, isNav4Enabled: isNav4Enabled })=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: isEnableRightSidebarEnabled ? `calc(
    100vw - var(--leftPanelWidth, 0px) - var(--leftSidebarWidth, 0px) -
      var(--rightPanelWidth, 0px) - var(--rightSidebarWidth, 0px)
  - ${"var(--ds-space-025, 2px)"}) !important` : isNav4Enabled ? '100%' : `calc(100% - ${"var(--ds-space-025, 2px)"})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginLeft: isNav4Enabled ? "var(--ds-space-0, 0px)" : "var(--ds-space-025, 2px)",
        transition: 'width 300ms cubic-bezier(0.2, 0, 0, 1) 0s',
        flexFlow: 'row wrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minWidth: !isEnableRightSidebarEnabled && !disableMinWidth ? 700 : '',
        '@media print': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            width: '100% !important'
        }
    }));
$370afc622ad38e0a$export$b5bdfcb4cafd161b.displayName = 'MainContentContainer';
const $370afc622ad38e0a$export$b84f0b2bc7887721 = (0, $gwrgp.default)("div", {
    target: "e6tglj31"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: props?.showPanel ? 'block' : 'none'
    }));
const $370afc622ad38e0a$export$4f2bba08a8d0c194 = (0, $gwrgp.default)("div", {
    target: "e6tglj32"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: props?.showPanel ? 'block' : 'none',
        zIndex: 12,
        // needs to be above 10 so it covers floating sticky table rows
        width: '100%',
        position: 'fixed',
        backgroundColor: "var(--ds-surface, #FFFFFF)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: !props?.isNav4Enabled && props?.isFullWidth ? '0' : 'var(--leftSidebarWidth)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        !props?.isNav4Enabled && props?.isFullWidth ? 'none' : 'calc( 100vw - var(--leftPanelWidth, 0px) - var(--leftSidebarWidth, 0px) - var(--rightPanelWidth, 0px) - var(--rightSidebarWidth, 0px) )'
    }));
const $370afc622ad38e0a$export$f0626b55b8fc2197 = (0, $gwrgp.default)("div", {
    target: "e6tglj33"
})(()=>({
        height: 'var(--atl-general-webpanel-height)'
    }));
const $370afc622ad38e0a$export$2ac536f43b2b4617 = (0, $gwrgp.default)("div", {
    target: "e6tglj34"
})(()=>({
        height: 'var(--forge-page-banner-height)'
    }));
const $370afc622ad38e0a$export$905efa1400f24d18 = (0, $gwrgp.default)("div", {
    target: "e6tglj35"
})({
    name: "17r9j9j",
    styles: "margin-top:0;box-sizing:border-box;clear:both;position:relative;width:100%;display:flex;flex:0 1 auto;min-height:unset;"
});
const $370afc622ad38e0a$var$contentBodyDefaults = ()=>({
        background: "var(--ds-surface, #FFFFFF)",
        boxSizing: 'border-box',
        verticalAlign: 'top',
        width: '100%',
        minHeight: 'initial'
    });
const $370afc622ad38e0a$export$e7f760d742ca707f = (0, $gwrgp.default)("div", {
    target: "e6tglj36"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$370afc622ad38e0a$var$contentBodyDefaults(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...props.topElementStyle,
        padding: 0,
        width: '100%'
    }));
const $370afc622ad38e0a$export$cc84a1cb61e1d196 = (0, $gwrgp.default)("div", {
    target: "e6tglj37"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$370afc622ad38e0a$var$contentBodyDefaults(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...props.topElementStyle,
        padding: 0,
        width: '100%',
        containerType: 'inline-size',
        containerName: 'content-body-container'
    }));
// TODO: remove this when confluence-previews no longer used
var $370afc622ad38e0a$var$_ref = {
    name: "5bwef6",
    styles: ".cp-container[role='dialog']{z-index:350;}"
};
const $370afc622ad38e0a$export$33d0451cd012d019 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lhCUr.Global), {
        // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
        styles: $370afc622ad38e0a$var$_ref
    });

});




//# sourceMappingURL=MainLayout.cae2f144.js.map
